import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ManualEventType } from "../codegen/graphql";

export const useEventTypeLabels = (): Record<ManualEventType, string> => {
    const { t } = useTranslation();
    return useMemo(() => ({
        [ManualEventType.ASSET_MAINTENANCE]: t('Maintenance'),
        [ManualEventType.ASSET_REPAIR]: t('Repair'),
        [ManualEventType.ASSET_INSTALL]: t('Install Asset'),
        [ManualEventType.ASSET_REMOVE]: t('Remove Asset'),
        [ManualEventType.ASSET_EXCHANGE]: t('Exchange'),
        [ManualEventType.ASSET_DELETE]: t('Delete Asset'),
        [ManualEventType.ASSET_ONSITE_INTERVENTION]: t('On-site Intervention'),
        [ManualEventType.ASSET_VACUUM_CHECK]: t('Vacuum Check'),
        // IoT commissioning checklist (IBM-1045) — the event type arrived with the IBM-1039 schema regeneration.
        [ManualEventType.ASSET_IOT_COMMISSIONING]: t('IoT Commissioning'),
    }), [t]);
};
